(() => {
  const PAGE_SIZE = 20;
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR');
  function init(root) {
    if (root.dataset.dmReviewsReady) return;
    root.dataset.dmReviewsReady = 'true';
    const form = root.querySelector('[data-dm-reviews-filters]');
    const nav = root.querySelector('[data-dm-reviews-pagination]');
    const pager = nav.firstElementChild;
    const status = root.querySelector('[data-dm-reviews-status]');
    const heading = root.querySelector('[data-dm-reviews-heading]');
    const ratingInput = form.elements.rating;
    const queryInput = form.elements.q;
    const entries = Array.from(root.querySelectorAll('[data-dm-review]'), (element) => ({
      element, rating: element.dataset.rating, text: normalize(element.textContent)
    }));
    const href = (page, rating, q) => '#dm-reviews?' + new URLSearchParams({page: String(page), rating, q});
    function render() {
      const params = new URLSearchParams(location.hash.startsWith('#dm-reviews?') ? location.hash.slice(12) : '');
      const rating = /^[1-5]$/.test(params.get('rating') || '') ? params.get('rating') : '';
      const q = (params.get('q') || '').slice(0, 200);
      const query = normalize(q.trim());
      const matched = entries.filter((entry) => (!rating || entry.rating === rating) && (!query || entry.text.includes(query)));
      const pages = Math.max(1, Math.ceil(matched.length / PAGE_SIZE));
      const requested = Number(params.get('page'));
      const page = Number.isSafeInteger(requested) && requested > 0 ? Math.min(requested, pages) : 1;
      const start = (page - 1) * PAGE_SIZE;
      const visible = new Set(matched.slice(start, start + PAGE_SIZE));
      entries.forEach((entry) => { entry.element.hidden = !visible.has(entry); });
      ratingInput.value = rating;
      queryInput.value = q;
      status.textContent = matched.length ? `${start + 1}–${Math.min(start + PAGE_SIZE, matched.length)} de ${matched.length} comentários. Página ${page} de ${pages}.` : 'Nenhum comentário encontrado para esses filtros.';
      pager.replaceChildren();
      for (const [label, target] of [['Anterior', page - 1], ['Próxima', page + 1]]) {
        if (target < 1 || target > pages) continue;
        const link = document.createElement('a');
        link.textContent = label;
        link.href = href(target, rating, q);
        link.addEventListener('click', () => { heading.focus(); });
        pager.append(link);
      }
      nav.hidden = pages < 2;
    }
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const hash = href(1, ratingInput.value, queryInput.value);
      if (location.hash === hash) render(); else location.hash = hash;
    });
    form.addEventListener('reset', (event) => {
      event.preventDefault();
      const hash = href(1, '', '');
      if (location.hash === hash) render(); else location.hash = hash;
    });
    window.addEventListener('hashchange', render);
    render();
    form.hidden = false;
  }
  const mount = (scope) => {
    if (scope.matches?.('[data-dm-reviews-page]')) init(scope);
    scope.querySelectorAll('[data-dm-reviews-page]').forEach(init);
  };
  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
